module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('video-player', {
    ref: "videoPlayer",
    attrs: {
      "options": _vm.compiledVjsOptions
    },
    on: {
      "ready": function($event) {
        _vm.$emit('ready', $event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9b8edf72!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/poly-video/index.vue
// module id = 2112
// module chunks = 2